import React from "react";
import SearchCommunties from "./SearchCommunties";
import { Box } from "@mui/material";

function FindCommunitiesContainer() {
  return (
    <Box
      sx={{
        marginTop: {
          xs: "68px",
          md: "0px",
        },
        display: "flex",
        flexDirection: "column",
        flex: 1,
      }}
    >
      <SearchCommunties />
    </Box>
  );
}

export default FindCommunitiesContainer;
